import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import Button from 'ui/atoms/Button/Button';
import Icon from 'ui/atoms/Icon/Icon';
import Typography from 'ui/atoms/Typography/Typography';
import ComponentWrapper from 'ui/templates/ComponentWrapper/ComponentWrapper';

export interface Props {
  handleOnButtonClick?: () => void;
}

const NoInstallers: React.FC<React.PropsWithChildren<Props>> = ({ handleOnButtonClick }) => {
  const { translation } = useTranslation();
  return (
    <ComponentWrapper
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      gap="1.5rem"
      width="28rem"
      height="16rem"
      id="no-installers-groups-label"
    >
      <Icon name="Installers" width={56} height={56} viewBox="0 0 24 24" />
      <Typography variant="title4">{translation.no_installers}</Typography>
      <ComponentWrapper flexDirection="column" justifyContent="center" alignItems="center">
        <Typography variant="body4">{`${translation.there_are_no_installers_added}.`}</Typography>
        <Typography variant="body4">{translation.click_add_to_add_a_new_installer}</Typography>
      </ComponentWrapper>
      <ComponentWrapper width="11rem">
        <Button onClick={handleOnButtonClick} id="no-installers-groups-button">
          {translation.add}
        </Button>
      </ComponentWrapper>
    </ComponentWrapper>
  );
};

export default NoInstallers;
